export const STORAGE_KEYS = {
  TENANT: 'TENANT_TOKEN',
  TOKEN: 'AUTH_TOKEN',
  USER: 'user'
}
